<template element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" v-loading="loading">
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import { usercenterinfo } from "@/api/home";
export default {
  data() {
    return {};
  },
  watch: {},
  methods: {
    async usercenterinfo() {
      const { data: res } = await usercenterinfo();
      const path = this.$route.path;
      if (res.code == 0) {
        if (path == "/") {
          this.$router.push("/unIndex");
        } else {
          this.$router.push(path);
        }
      }
    },
  },
  components: {
    // 声明子组件名字
  },
  created() {
	  this.usercenterinfo()
  },
  computed: {},
  mounted() {},
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue